/* Meal tickets (docs/plans/phase3-kitchen-and-housekeeping.md §1.4): A4, black on white, two
   tickets across, each kept whole on one page. Tokens only. */

.tickets {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4mm;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ticket {
  display: flex;
  flex-direction: column;
  gap: 1mm;
  padding: 3mm;
  border: 1px solid var(--ink);
  break-inside: avoid;
}

.ticketBed {
  font: var(--t-body-strong);
}

.ticketLine {
  margin: 0;
  overflow-wrap: anywhere;
}

.ticketLabel {
  font: var(--t-body-strong);
}
